<style lang="less" scoped src="../css/common.less"></style>
<style lang="less" scoped>
    .content {
        margin-top: 20px;
        .sub-item-container {
            padding: 10px 10px 10px 71px;
        }
    }
    .sub-item-image{
        width: 50px;
        height: 50px;
        img {
            vertical-align: middle;
            max-width: 100%;
            max-height: 100%;
        }
    }
    .image-normal{
        display: inline-block;
        vertical-align: top;
        margin-right: 5px;
    }
</style>
<template>
    <div class="wrap">
        <h2 class="text-center">商品上架详情</h2>
        <div class="content" v-if="item.id">
            <Row class="line" :gutter="4">
                <i-col span="12">
                    <div class="label">产品负责人</div>
                    <div class="value">{{item.apply_user}}</div>
                </i-col>
                <i-col span="12">
                    <div class="label">填制人</div>
                    <div class="value">{{item.fill_user}}</div>
                </i-col>
            </Row>
            <Row class="line" :gutter="4">
                <i-col span="12">
                    <div class="label">上架平台</div>
                    <div class="value">{{$onlineUtil.getPlatformName(item.platforms)}}</div>
                </i-col>
            </Row>
            <!-- 商城 -->
            <div v-if="item.platforms === 'mall'">
                <Divider orientation="left">商城</Divider>
                <Row class="line" :gutter="4">
                    <i-col span="24">
                        <div class="line">
                            <div class="label">商品ID</div>
                            <div class="value" v-if="item.mall_item.item_id">{{item.mall_item.item_id}}</div>
                            <div class="value" v-else>暂无</div>
                        </div>
                    </i-col>
                </Row>
                <Row class="line" :gutter="4">
                    <i-col span="24">
                        <div class="line">
                            <div class="label">宝贝标题</div>
                            <div class="value">{{item.title}}</div>
                        </div>
                    </i-col>
                </Row>
                <SubItem class="sub-item-container" :item="item" list_key="mall_sub_items"></SubItem>
                <Row class="line" :gutter="4">
                    <i-col span="12">
                        <div class="label">首页标题</div>
                        <div class="value">{{item.formal_title}}</div>
                    </i-col>
                    <i-col span="12">
                        <div class="label">内部简称</div>
                        <div class="value">{{item.short_name}}</div>
                    </i-col>
                </Row>
                <Row class="line" :gutter="4">
                    <i-col span="12">
                        <div class="label">商品介绍</div>
                        <div class="value">{{ item.short_description || '未填写'}}</div>
                    </i-col>
                </Row>
                <Row class="line">
                    <div class="label">服务承诺</div>
                    <div class="value" >
                        <template v-if="pledgeTagDetails.length">
                            <span style="margin-left: 10px;" v-for="tag in pledgeTagDetails" :key="tag.id">
                            <span>{{ tag.name }}</span>
                            <Poptip max-width="1000" placement="bottom-start" trigger="hover"> 
                                <Icon type="ios-help-circle-outline"/>
                                <div slot="content">
                                <div>服务承诺标题：{{ tag.name }}</div>
                                <div>服务承诺内容：{{ tag.detail }}</div>
                                </div>
                            </Poptip>
                            </span>
                        </template>
                        <template v-else>
                            <span>未选择，展示默认服务承诺</span>
                        </template>
                    </div>
                </Row>
                <Row class="line" :gutter="4">
                    <i-col span="12">
                        <div class="label">品类</div>
                        <div class="value">{{$onlineUtil.getCategoryName(item.category_id)}}</div>
                    </i-col>
                    <i-col span="12">
                        <div class="label">类型</div>
                        <div class="value">{{$onlineUtil.getItemTypeName(item.item_type)}}</div>
                    </i-col>
                </Row>
                <Row class="line" :gutter="4">
                    <i-col span="12">
                        <div class="label">展示</div>
                        <div class="value">{{$onlineUtil.getShowTypeName(item.show_type)}}</div>
                    </i-col>
                    <i-col span="12">
                        <div class="label">包邮</div>
                        <div class="value">{{item.free_postage ? '是' : '否'}}</div>
                    </i-col>
                </Row>
                <Row class="line" :gutter="4">
                    <i-col span="12">
                        <div class="label">预约开售时间</div>
                        <div class="value">{{item.sale_time ? $util.formatTime(item.sale_time) : '-'}}</div>
                    </i-col>
                    <i-col span="12">
                        <div class="label">赠品属性</div>
                        <div class="value">{{item.extra_tag}}</div>
                    </i-col>
                </Row>
                <div class="line">
                    <div class="label">首页小图</div>
                    <div class="value">
                        <MallImage :src="item.image_small" v-if="item.image_small"></MallImage>
                        <span v-else>-</span>
                    </div>
                </div>
                <div class="line">
                    <div class="label">滚动大图</div>
                    <div class="value" v-if="item.image_normal">
                        <MallImage class="image-normal" :src="image_path" v-for="image_path in image_normal_paths" :key="image_path"></MallImage>
                    </div>
                    <div class="value" v-else>-</div>
                </div>
                <div class="line">
                    <div class="label">主图视频</div>
                    <div class="value" >
                        <video style="max-width:300px" controls v-if="item.video_url">
                            <source :src="mallVideoUrl(item.video_url)">
                        </video>
                        <span v-else>未上传视频</span>
                    </div>
                </div>
                <div class="line">
                    <div class="label">主图视频封面</div>
                    <div class="value" v-if="item.video_cover_url">
                        <MallImage :src="item.video_cover_url" v-if="item.video_cover_url"></MallImage>
                        <span v-else>未上传封面图片</span>
                    </div>
                    <div class="value" v-else>-</div>
                </div>
            </div>
            <!-- 淘宝 -->
            <div v-if="item.platforms === 'taobao'">
                <Divider orientation="left">淘宝</Divider>
                <Row class="line" :gutter="4">
                    <i-col span="24">
                        <div class="line">
                            <div class="label">宝贝标题</div>
                            <div class="value">{{item.taobao_title}}</div>
                        </div>
                    </i-col>
                </Row>
                <SubItem class="sub-item-container" :item="item" list_key="taobao_sub_items"></SubItem>
            </div>
            <!-- 天猫 -->
            <div v-if="item.platforms === 'tmall'">
                <Divider orientation="left">天猫</Divider>
                <SubItem class="sub-item-container" :item="item" list_key="tmall_sub_items"></SubItem>
            </div>
            <Divider></Divider>
            <div class="line">
                <div class="label">处理方式</div>
                <div class="value" :class="$onlineUtil.getActionType(action).color_class">{{$onlineUtil.getActionType(action).name}}</div>
            </div>
            <div class="line" v-if="action === 'update'">
                <div class="label">更新内容</div>
                <div class="value">
                    <ItemDiff type="text" :item_id="item.mall_item_id"></ItemDiff>
                </div>
            </div>
            <div class="line user-flow" v-if="item.user_flow">
                <div class="label">流程状态</div>
                <div class="value">
                    <UserFlow :user_flow="item.user_flow"></UserFlow>
                </div>
            </div>
        </div>


        <div class="text-center" v-if="loading">
            <Spin size="large" fix></Spin>
        </div>
    </div>
</template>
<script>
    import ViewerItem from '../item';
    import OnlineUtil from '../../../stock_online/libs/util';
    import ItemPreview from '../../../stock_online/components/preview';
    import ItemDiff from '../../../stock_online/components/diff';
    import SubItem from '../../../stock_online/components/sub_item';
    import MallImage from '../../../stock_online/components/mall_image';
    export default {
        components: { ViewerItem, ItemPreview, ItemDiff, SubItem, MallImage },
        props: {
            model_id: {
                type: Number
            }
        },
        data(){
            return {
                item: {
                    mall_item: {}, 
                    mall_online_sub_items: [],
                    image_normal: '',
                    pledge_tag_ids:[]
                },
                action: '',
                loading: false,
                pledgeTags: []
            }
        },
        computed: {
            image_normal_paths() {
                return this.item.image_normal.split(';');
            },
            pledgeTagDetails() {
                return this.pledgeTags.filter(tag => this.item.pledge_tag_ids.includes(tag.id));
            }
        },
        created(){
            this.$onlineUtil = OnlineUtil;
            this.getMallOnlineItem();
        },
        mounted(){
            //
        },
        methods: {
            getMallOnlineItem(){
                this.loading = true;
                Promise.all([OnlineUtil.getMallOnlineItemDetail(this.model_id),OnlineUtil.getPledgeTags()]).then(([data,pledgeTags]) => {
                    this.item = data.item;
                    this.pledgeTags = pledgeTags;
                    this.action = data.action;
                }).catch((e) => {
                    this.$Modal.error({title: '错误', content: e.message});
                }).finally(() => {
                    this.loading = false;
                })
            },
            mallVideoUrl (path) {
                return `https://fulfillment.bczcdn.com/rc201603281546${path}`;
            },
        }
    }
</script>
